import { create10DigitsTrip } from "2ch-trip/dist/creators/10digits.js";
import { maskManualTripMarker } from "./profile";

/**
 * Generate the classic 2ch/5ch-style ten-character trip.
 *
 * The trip key stays on the client. Only this derived value is sent to the
 * room server, so other clients never receive the key entered after `#`.
 */
export function create2chTrip(key: string): string {
  const normalized = key;
  if (!normalized) return "";
  // Keep profiles saved by the first tripcode rollout from being hashed a
  // second time when the app reconnects after an update.
  if (/^◆[./0-9A-Za-z]{10}$/u.test(normalized)) return normalized;
  return `◆${create10DigitsTrip(normalized)}`;
}

export function formatPlayerIdentity(name: string, trip = ""): string {
  const safeName = maskManualTripMarker(name);
  return trip ? `${safeName} ${trip}` : safeName;
}
